import React from 'react'
import { Cell } from 'rsuite-table'
import './StatusCell.scss'

type RowData = {
  [key: string]: string | boolean
}

type ActiveStatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const ActiveStatusCell: React.FC<ActiveStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const isActive = rowData?.[dataKey]

  const statusClass = isActive ? 'status-running' : 'status-outdated'
  const statusLabel = isActive ? 'Active' : 'Inactive'

  return (
    <Cell {...props}>
      <span className={`status-cell ${statusClass}`}>{statusLabel}</span>
    </Cell>
  )
}

export default ActiveStatusCell
